import React, { useEffect, useContext } from "react";
import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";
import { styled } from "@mui/system";
import {
  Dashboard as DashboardIcon,
  ShoppingCart as OrdersIcon,
  Menu as MenuIcon,
  Logout as LogoutIcon,
  AccountCircle as ProfileIcon,
  ShoppingBag as ShopNowIcon,
} from "@mui/icons-material";
import RateReviewIcon from "@mui/icons-material/RateReview";
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { BusinessContext } from "../BusinessContext";
import { signOut} from "firebase/auth";
import { auth } from "../../firebase/FirebaseConfig";
import { useNavigate } from "react-router-dom";
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import { useTranslation } from "react-i18next";
import { isAdminAccount } from "../../globals/userRoles";



const USFlag = "https://pointgenie.sfo3.cdn.digitaloceanspaces.com/united-states.png";
const SpainFlag = "https://pointgenie.sfo3.cdn.digitaloceanspaces.com/spanish.png";
const logo = `${process.env.PUBLIC_URL}/logo-light.png`;

// Styled Components
const StyledSelect = styled(Select)({
  borderRadius: "8px",
  border: "2px solid white",
  padding: "4px 8px",
  display: "flex",
  alignItems: "center",
  gap: "8px",
  marginTop: "12px",
  "& .MuiSelect-select": {
    display: "flex",
    alignItems: "center",
    padding: "4px 8px",
  },
  "& fieldset": {
    border: "none",
  },
});

const StyledMenuItem = styled(MenuItem)({
  fontSize: "16px",
  fontFamily: "Nunito",
});

const menuItems = [
  {
    id: 1,
    text: "Dashboard",
    icon: <DashboardIcon />,
    url: "/dashboard/dashboard",
    color: "#2196f3",
  },
  {
    id: 2,
    text: "Menu",
    icon: <MenuIcon />,
    url: "/dashboard/menu",
    color: "#9c27b0",
  },
  {
    id: 3,
    text: "Orders",
    icon: <OrdersIcon />,
    url: "/dashboard/orders",
    color: "#ff9800",
  },
  {
    id: 10,
    text: "Customer Orders",
    icon: <OrdersIcon />,
    url: "/dashboard/customerorders",
    color: "#00e676",
  },
  {
    id: 4,
    text: "Offers",
    icon: <LocalOfferIcon />,
    url: "/dashboard/offers",
    color: "red",
  },
  {
    id: 5,
    text: "Genie Tag",
    icon: <AutoAwesomeIcon />,
    url: "/dashboard/genietags",
    color: "#4caf50",
  },
  {
    id: 13,
    text: "Business Report",
    icon: <LibraryBooksIcon />,
    url: "/dashboard/businessreport",
    color: "#ff9800",
  },
  {
    id: 12,
    text: "Photos",
    icon: <PhotoLibraryIcon />,
    url: "/dashboard/photos",
    color: "#f10cd9",
  },
  {
    id: 6,
    text: "Social Networks",
    icon: <RateReviewIcon />,
    url: "/dashboard/sociallinks",
    color: "#4caf50",
  },
  {
    id: 7,
    text: "Shop Now",
    icon: <ShopNowIcon />,
    // url: "/dashboard/Shop Now",
    color: "#f10cd9",
  },
 
  {
    id: 8,
    text: "Profile",
    icon: <ProfileIcon />,
    url: "/dashboard/profile",
    color: "#ffffff ",
  },
  {
    id: 9,
    text: "Logout",
    icon: <LogoutIcon />,
    color: "#f44336",
  },
];

const Sidebar = ({ selectedItem, onMenuItemClick }) => {
  const { businesses, selectedBusinessId, updateBusinessId, isLoading ,fetchUserDetails,username,userdetails} =
    useContext(BusinessContext);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const handleLogout = async () => {
    try {
      console.log("Logging out...");
      await signOut(auth);
      console.log("Sign out successful!");

      // Clear all auth-related data
      localStorage.removeItem("idToken");
      localStorage.removeItem("firebaseUser");
      localStorage.removeItem("userEmail");
      localStorage.removeItem("username");
      localStorage.removeItem("PhoneNumber");
      localStorage.removeItem("plateCode");
      localStorage.removeItem("firstName");
      localStorage.removeItem("businessId");
      localStorage.removeItem("googleToken");
      localStorage.removeItem("lastName");
      localStorage.removeItem("BusinessName");
      navigate("/login");
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  const handleItemClick = (item) => {
    if (item.id === 9) {
      handleLogout();
    } else if (item.id === 7) {
      window.open(`https://www.pointgenie.com/#product_form`, "_blank");
    } else {
      onMenuItemClick(item.id);
      if (item.url) {
        navigate(item.url);
      }
    }
  };
  

  useEffect(() => {
    fetchUserDetails();
  }, []);
  
  const isAdmin = isAdminAccount(userdetails);
  const dynamicMenuItems = menuItems.filter((item) => isAdmin || item.id !== 10);

if (isAdmin) {
  const customerOrdersIndex = dynamicMenuItems.findIndex((item) => item.id === 10);
  if (customerOrdersIndex !== -1) {
    dynamicMenuItems.splice(customerOrdersIndex + 1, 0, {
      id: 11,
      text: "Business Reports",
      icon: <LibraryBooksIcon />,
      url: "/dashboard/businessreports",
      color: "#eeda0c",
    });
  }
}

  
  
  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        overflow: "hidden",
        backgroundColor: "#1a237e",
        color: "white",
        display: "flex",
        flexDirection: "column",
       }}
    >
      <Box sx={{ px: 2, pt: 1 }}>
        <Typography sx={{ fontSize: "23px" }}>
        {/* {t("Welcome")},{" "} */}
          <span style={{ color: "green", fontWeight: "bold" }}>
          {username}
          </span>
        </Typography>
      </Box>
      <Box sx={{ px: 2, pt: 1, display: "flex", gap: 2, alignItems: "center" }}>
        {/* English */}
        <Box
          onClick={() => changeLanguage("en")}
          sx={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            gap: 1,
            px: 1.5,
            border: currentLang ==="en"? "solid 1px":"",
            borderRadius: currentLang ==="en"? "2px":"",
            backgroundColor: currentLang ==="en"? "#ffff" :"",
            paddingTop: currentLang ==="en"? "1px":"",
            paddingBottom: currentLang ==="en"? "2px":"",
          }}
        >
          <Box
            component="img"
            src={USFlag} // Replace with valid path or URL
            alt="US Flag"
            sx={{ width: 20, height: 20 }}
          />
          <Typography sx={{ fontSize: "15px",color:currentLang ==="en"? "#235d15" :"whitesmoke",fontWeight:"bold" }}>English</Typography>
        </Box>

        {/* Spanish */}
        <Box
          onClick={() => changeLanguage("es")}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            cursor: "pointer",
            py: 0.5,
            border: currentLang ==="es"? "solid 1px":"",
            borderRadius: currentLang ==="es"? "2px":"",
            backgroundColor: currentLang ==="es"? "#ffff" :"",
            paddingTop: currentLang ==="es"? "2px":"",
            paddingBottom: currentLang ==="es"? "2px":"",
            paddingLeft: currentLang ==="es"? "3px":"",
            paddingRight: currentLang ==="es"? "3px":"",
          }}
        >
          <Box
            component="img"
            src={SpainFlag} // Replace with valid path or URL
            alt="Spain Flag"
            sx={{ width: 20, height: 20, }}
          />
          <Typography sx={{ fontSize: "15px" ,color:currentLang ==="es"? "#235d15" :"whitesmoke",fontWeight:"bold" }}>Spanish</Typography>
        </Box>
      </Box>
      <Box sx={{ px: "8px", pt: "8px" }}>
        <FormControl sx={{ width: "100%" }}>
          <StyledSelect
            value={selectedBusinessId}
            onChange={(e) => updateBusinessId(e.target.value)}
            displayEmpty
            sx={{ color: "white", "& .MuiSvgIcon-root": { color: "white" } }}
            renderValue={() => {
              const selectedBusiness = businesses.find(
                (b) => b.id === selectedBusinessId
              );
              return (
               <Box display="flex" alignItems="center" gap={1} color="white">
              {selectedBusiness
          ? selectedBusiness.name.length > 20
            ? selectedBusiness.name.slice(0, 20) + "..."
            : selectedBusiness.name
          :  t("Select Business")}

                </Box>
              );
            }}
          >
            {isLoading ? (
              <StyledMenuItem disabled>Loading businesses...</StyledMenuItem>
            ) : businesses.length > 0 ? (
              businesses.map((business,index) => {
                const words = business.name.split(" ").filter((word) => word);
                const initials =
                  words.length > 1 ? words[0][0] + words[1][0] : words[0][0];

                return (

                  <StyledMenuItem
                    key={business.id}
                    value={business.id}
                    sx={{
                      borderBottom: index === businesses?.length - 1 ? "none" : "1px solid #ccc",
                    }}
                  >
                   <Box display="flex" alignItems="center" gap={1}>
                      <Box
                        sx={{
                          width:{ xs:25,sm:30},
                          height: { xs:25,sm:30},
                          borderRadius: "50%",
                          backgroundColor: "#1976d2",
                          color: "white",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "12px",
                        }}
                      >
                        {initials}
                      </Box>
                     <Typography component={"span"} sx={{fontSize:{xs:"14px",sm:"16px"}, fontFamily:"Nunito"}}>{business.name}</Typography> 
                    </Box>
                  </StyledMenuItem>
                );
              })
            ) : (
              <StyledMenuItem disabled>No businesses available</StyledMenuItem>
            )}
          </StyledSelect>
        </FormControl>
      </Box>
      {/* 
      <Box sx={{ px: 2, pb: 1, pt: 3 }}>
        <Typography variant="h6" sx={{ color: "white" }}>
          Dashboard
        </Typography>
      </Box> */}

      <List sx={{ flexGrow: 1, overflowY: "auto", 
      overflowX:"hidden",
        scrollbarWidth: "4px", 
        "&::-webkit-scrollbar": {
          width: "4px", 
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: " grey",
          borderRadius: "10px",
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: "#1a237e",
        }, }}>
        {dynamicMenuItems.map((item) => (
          <ListItem
            key={item.id}
            onClick={() => handleItemClick(item)}
            sx={{
              backgroundColor:
                selectedItem === item.text
                  ? "rgba(255, 255, 255, 0.1)"
                  : "transparent",
              "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.2)" },
              borderRadius: "8px",
              margin: "4px 8px",
              cursor:"pointer"
            }}
          
          >
            <ListItemIcon sx={{ color: item.color }}>{item.icon}</ListItemIcon>
            <ListItemText primary={t(item.text)} />
          </ListItem>
        ))}
      </List>
      <Box sx={{pl:"20px",py:"20px"}}>
      <Box
      component="img"
      src={logo}
      sx={{width:"150px",height:"auto",cursor:"pointer"}}
      />
      </Box>
    
    </Box>
  );
};

export default Sidebar;
